var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobsMenuIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24567 1.88583L5.8 3H3C1.34315 3 0 4.34315 0 6V17C0 18.6569 1.34315 20 3 20H17C18.6569 20 20 18.6569 20 17V6C20 4.34315 18.6569 3 17 3H14.2L13.7543 1.88583C13.2987 0.746853 12.1956 0 10.9689 0H9.0311C7.80439 0 6.70126 0.746853 6.24567 1.88583ZM10.9689 2H9.0311C8.62219 2 8.25449 2.24895 8.10262 2.62861L7.95407 3H12.0459L11.8974 2.62861C11.7455 2.24895 11.3778 2 10.9689 2ZM17 5C17.5523 5 18 5.44771 18 6V9C18 9.55228 17.5523 10 17 10H12.7324C12.3866 9.4022 11.7403 9 11 9H9C8.25972 9 7.61337 9.4022 7.26756 10H3C2.44772 10 2 9.55229 2 9V6C2 5.44772 2.44772 5 3 5H17ZM7.26756 12H3C2.64936 12 2.31278 11.9398 2 11.8293V17C2 17.5523 2.44772 18 3 18H17C17.5523 18 18 17.5523 18 17V11.8293C17.6872 11.9398 17.3506 12 17 12H12.7324C12.3866 12.5978 11.7403 13 11 13H9C8.25972 13 7.61337 12.5978 7.26756 12Z",
    fill: "#6F767E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobsMenuIcon2);
export default __webpack_public_path__ + "static/media/jobs-menu-icon-2.f6449f3e8fe0a78c982af789db87289a.svg";
export { ForwardRef as ReactComponent };